import axios from 'axios'
import { alert } from "devextreme/ui/dialog" 
var baseUri = "WebApi.asmx/api/attributeTypeModusService"; 
const store = {};
const mutations = { 
    GET_ATTRIBUTETYPE_MODUS_LIST(state, posts) {
        state.attributeTypeModusList = posts.list;
    }, 
};
const state = { 
    attributeTypeModusList: []
};

const getters = {};

const actions = {
    getAttributeTypeModusList({ commit }, data) {
        axios
            .get(baseUri + '/GetList?AtyId=' + data.atyId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ATTRIBUTETYPE_MODUS_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    }, 
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}